import { AnaColumn } from "../forms-template.service";

export const ConfigurazioneRentri: AnaColumn[] = [


    {
      itemType: "group", caption: 'Configurazione RENTRi', class: '', colCount: "1", data: [
  
        {
          type: 'campo', dataField: "id", colVisible: true, dataType: "", caption: "Codice sede", hideOnEdit: true,
  
        },
  
  
  
        {
          type: 'campo', dataField: "descrizioneSoggetto", colVisible: true, dataType: "", caption: "Azienda", hideOnEdit: true,
          groupIndex: 1,
  
  
        },
        {
          type: 'campo', dataField: "descrizioneSede", colVisible: true, dataType: "", caption: "Descrizione", hideOnEdit: true,
  
        },
  
  
        {
          type: 'campo', dataField: "idSedeRentri", caption: "Codice sede rentri", colVisible: true, dataType: "", hideOnEdit: true,
  
        },
  
  
        {
          type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
  
          button: {
            name: 'AssociaSedeRentri',
            hint: 'Scarica sede dal R.E.N.T.R.i',
            icon: 'glyphicon icon-icona-app-rentri',
  
            text: 'Associa con R.E.N.T.R.i',
            type: 'text',
            event: 'AssociaSedeRentri'
          }
        },
        {
          type: 'button', dataField: "", colVisible: true, dataType: "", hideOnEdit: true,
  
          button: {
            name: 'RimuoviSedeRentri',
            hint: 'Rimuovi sede R.E.N.T.R.i associata',
            icon: 'glyphicon fa fa-trash',
  
            text: 'Rimuovi sede R.E.N.T.R.i associata',
            type: 'text',
            event: 'RimuoviSedeRentri'
          }
        },
  
        /*{
          type: 'button', dataField: "", colVisible: true, dataType: "", caption: "", hideOnEdit: true,
          width:'90',
          button:{ 
            name: 'GeneraPDFFir',
            hint: 'Genera PDF FIR',
            icon: 'glyphicon far fa-file-pdf',
            
            text: 'Download PDF FIR',
            type: 'text',
            event: 'GeneraPDFFir'
          }
        },*/
  
        {
          type: 'campo', dataField: "autoreAnnullamento", colVisible: false, dataType: "", caption: "", hideOnEdit: true,
  
        },
  
  
  
  
  
  
  
      ]
    }
  ]